import React from 'react'
import { Redirect } from 'react-router-dom'

interface IRedirector {
  pathToRedirect?: string
}

export const Redirector = ({ pathToRedirect }: IRedirector) =>
  pathToRedirect ? <Redirect push to={pathToRedirect} /> : null
